module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        This head of loss is calculated using the BC Legal General Damages PSLA Calculator.\n            This assesses common law awards according to 'age' and 'duration' of symptoms-the period between onset\n            of disease and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('em', [_vm._v("The relevant excerpt from the PLSA Calculator is shown below.")]), _vm._v(" "), _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed u-margin-top-20"
  }, [_c('thead', [_vm._m(0), _vm._v(" "), _c('tr', _vm._l((_vm.durationLabels), function(label) {
    return _c('th', [_vm._v("\n                " + _vm._s(label) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableResults), function(row, ageKey) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(_vm.ageLabels[ageKey]))]), _vm._v(" "), _vm._l((row), function(cell, cellIndex) {
      return _c('td', {
        style: (_vm.calcCellStyle(ageKey, cellIndex))
      }, [_vm._v("\n                " + _vm._s(_vm.currencyFormat(cell, "£", 0)) + "\n            ")])
    })], 2)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up To)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Duration of Symptoms (months)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30da3884!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/day-one/fatal/accordian-content/PslaModalContent.vue
// module id = 1629
// module chunks = 0